/**
 * useMemory — память проекта (контекст, решения, документы, поиск).
 */

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiFetch } from '@/api/client';

export interface ProjectContext {
  key: string;
  name: string;
  context: string;
}
export interface Decision {
  id: number;
  author: string;
  summary: string;
  rationale: string;
  expected_outcome: string;
  created_at: string;
}

export function useProjectContext() {
  return useQuery<ProjectContext>({
    queryKey: ['memory', 'context'],
    queryFn: () => apiFetch<ProjectContext>('/api/memory/context'),
  });
}

export function useSaveContext() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (context: string) => apiFetch('/api/memory/context', { method: 'PUT', json: { context } }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['memory', 'context'] }),
  });
}

export function useDecisions() {
  return useQuery<Decision[]>({
    queryKey: ['memory', 'decisions'],
    queryFn: () => apiFetch<Decision[]>('/api/memory/decisions'),
  });
}

export function useAddDecision() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (d: { summary: string; rationale?: string; expected_outcome?: string }) =>
      apiFetch('/api/memory/decisions', { method: 'POST', json: d }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['memory', 'decisions'] }),
  });
}
